// Config for marketing consent toggle on sign up
export const marketingConsentActivated = false;
// Brand privacy url to be added
export const brandPrivacyPolicyUrl =
  'https://www.marshall.com/us/en/policies/privacy-policy?srsltid=AfmBOooxQGiv4hMm0sTi4yssL8txGYsc9I8kB148gLzTfVggTTLw27uq';
